module.exports = __webpack_public_path__ + "static/media/FreedomEdge-30ml-logo.4e0ddb8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FreedomEdge-30ml-logo.png
// module id = 250
// module chunks = 0